// extracted by mini-css-extract-plugin
export default {"card":"Card_card__JEMFu","interactive":"Card_interactive__PQRN9","on":"Card_on__o0ZLC"};